// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__ySwWs","body":"Card_body__FHhUM"};